export const QueryConstants = {
    REDIRECT_TO: 'redirect_to',
    SHOW_POPUP: 'ShowPopup',
    REDIRECT_URL: 'redirectUrl',
};
